export function setVideoPlaying(state) {
  return {
    type: 'VIDEO_PLAYING',
    state
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/a_media_controls.js